import type { Device } from '@/types/api';

export type SetupStatus = 'waiting' | 'recognized';

// A device is "Recognized" once it has either joined the LoRaWAN network OR
// transmitted a reading at its current unit. The Join event lands ~1s after
// the meter's "L" goes solid; the first data uplink can take a meter cycle
// (minutes) longer. Either signal counts so the chip flips fast — Tanner's
// expectation is that pressing Join on the meter immediately drops the
// "Send Join Request" prompt.
//
// The signal/time render in SetupDeviceCard adds a second-tier check on
// post-assignment transmission so stale pre-reassignment readings can't
// leak into the card's signal area while the chip is recognized-via-join.
//
// Reassigning the device — or removing it from a property — resets
// UnitAssignedAt server-side, which naturally drops the device back to
// "Waiting" until the next post-assignment join or transmission.
export function deviceStatus(
  device: Pick<Device, 'lastSeenAt' | 'joinedAt' | 'unitAssignedAt'>,
): SetupStatus {
  if (!device.unitAssignedAt) return 'waiting';
  const assignedMs = new Date(device.unitAssignedAt).getTime();
  const seenMs = device.lastSeenAt ? new Date(device.lastSeenAt).getTime() : -Infinity;
  const joinedMs = device.joinedAt ? new Date(device.joinedAt).getTime() : -Infinity;
  return seenMs >= assignedMs || joinedMs >= assignedMs ? 'recognized' : 'waiting';
}
